// The typed API client (packages/api-client, generated from the API's OpenAPI) with the
// tablet's bearer-token fetch.
import { type ApiClient, ApiError, createApiClient, unwrap } from "@artisan/api-client";

import { authFetch } from "./auth";
import { apiBase } from "./env";

let client: ApiClient | null = null;

export function api(): ApiClient {
  client ??= createApiClient({ baseUrl: apiBase(), fetch: authFetch });
  return client;
}

export { ApiError, unwrap };

/** True for errors worth retrying later (no network, timeouts, 5xx, rate limits). */
export function isTransient(e: unknown): boolean {
  if (e instanceof ApiError) return e.status >= 500 || e.status === 429 || e.status === 408;
  return e instanceof TypeError || (e instanceof DOMException && e.name === "AbortError");
}

/** A message for the rep, in Mongolian. */
export function describeError(e: unknown): string {
  if (e instanceof ApiError) {
    switch (e.code) {
      case "invalid_credentials":
        return "И-мэйл эсвэл нууц үг буруу байна.";
      case "render_unavailable":
        return "AI render одоогоор идэвхгүй байна (серверт загвар тохируулаагүй).";
      case "storage_unavailable":
      case "storage_not_configured":
        return "Сервер дээр файл хадгалах сан тохируулаагүй байна.";
      case "engine_unavailable":
        return "Сонгосон AI загвар одоогоор ажиллахгүй байна. Өөр загвар сонгоно уу.";
      case "unknown_engine":
        return "Сонгосон AI загвар олдсонгүй. Жагсаалтаас дахин сонгоно уу.";
      case "unsupported_resolution":
        return "Энэ загвар сонгосон нягтралыг дэмжихгүй байна. Өөр нягтрал сонгоно уу.";
      case "too_many_images":
        return "Энэ загвар нэг удаад ийм олон барааг авахгүй байна. Барааг цөөлөх эсвэл өөр загвар сонгоно уу.";
      case "render_busy":
        return "Нэг зэрэг хэт олон render явж байна. Түр хүлээгээд дахин оролдоно уу.";
      case "no_active_organization":
        return "Байгууллага сонгоогүй байна.";
      default:
        return e.status >= 500 ? "Сервер түр ажиллахгүй байна. Дараа дахин оролдоно уу." : e.message;
    }
  }
  if (isTransient(e)) return "Сүлжээ алга. Интернэт орж ирэхэд дахин оролдоно.";
  return e instanceof Error ? e.message : String(e);
}
